import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { Api } from './api';
import { UserDetail } from '../models/user-details.model';
import { ProfilePicture } from '../models/profile-picture.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserDetailService {
  private endpoint = '/user-details';

  constructor(private api: Api) {}

  getUserDetails(
    page: number = 0,
    size: number = 20,
    sort: string = 'id,asc'
  ): Observable<UserDetail> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sort,
    };
    return this.api.get(this.endpoint, params);
  }

  getUserDetailsByUserId(userId: number): Observable<UserDetail> {
    return this.api.get(`${this.endpoint}?userId.equals=${userId}`);
  }

  createUserDetail(userDetail: Partial<UserDetail>): Observable<UserDetail> {
    return this.api.post(this.endpoint, userDetail);
  }

  updateUserDetail(
    id: number,
    userDetail: Partial<UserDetail>
  ): Observable<UserDetail> {
    return this.api.putGenerate(`${this.endpoint}/${id}`, userDetail);
  }

  deleteUserDetail(id: number): Observable<void> {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  getProfilePicture(userId: number): Observable<string> {
    const imageUrl = `${this.endpoint}/profile-picture/${userId}`;
    return of(`${environment.baseUrl}${imageUrl}`);
  }

  uploadProfilePicture(profilePicture: ProfilePicture): Observable<string> {
    return this.api.postText(
      `${this.endpoint}/upload-profile-picture`,
      profilePicture
    );
  }

  checkUserDetailExists(userId: number): Observable<boolean> {
    return this.api.get(`${this.endpoint}?userId.equals=${userId}`).pipe(
      map((response: any[]) => response.length > 0),
      catchError((err) => {
        if (err.status === 404) {
          return of(false);
        }
        return throwError(() => err);
      })
    );
  }
}
